<template>
  <div id="wrapper">

    <div class="normalheader transition">
      <div class="hpanel">
        <div class="panel-body">

          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Projects'}">Projects</router-link></li>
              <li><router-link :to="{name: 'ProjectDetails', params: {id: projectId}}">Project Overview</router-link></li>
              <li><router-link :to="{name: 'MailingReview', params: {project_id: projectId, question_id: questionId}}">Mailing Review</router-link></li>
              <li class="active"><router-link :to="{name: 'Mailing', params: {project_id: projectId, question_id: questionId, mailing_id: mailingId}}">Mailing</router-link></li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs" v-if="project">
            Mailing - <router-link class="font-bold text-info" :to="{name: 'ProjectDetails', params: {id: projectId}}">{{project.name}}</router-link>
          </h3>
          <small>Editing email text</small>
        </div>
      </div>
    </div>

    <div class="content">
      <form @submit="submitTemplate">

        <div class="hpanel no-margins">

          <div class="panel-heading">
            Email templates
          </div>

          <div class="row" v-if="template">
            <div class="col-xs-12 col-md-6">
              <div class="hpanel">

                <div class="panel-heading hbuilt">
                  Experts added through the platform
                </div>

                <div class="panel-body">
                  <div class="form-group ">
                    <label for="subject" class="required">Subject</label>
                    <input id="subject" v-model="template.subject" class="form-control"/>
                    <span v-if="errorSubject" class="has-error help-block text-danger">{{ errorSubject }}</span>
                  </div>

                  <div class="form-group">
                    <label for="body" class="required">Text body</label>
                    <trumbowyg id="body" style="height: 200px" v-model="template.body" :config="config" class="form-control" @tbw-paste="cleanUrl"></trumbowyg>
                    <span v-if="errorBody" class="has-error help-block text-danger">{{ errorBody }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xs-12 col-md-6">

              <div class="hpanel">

                <div class="panel-heading hbuilt">
                  Manually added experts
                </div>

                <div class="panel-body">
                  <div class="form-group ">
                    <label for="subjectManual" class="required">Subject Manually</label>
                    <input id="subjectManual" v-model="template.subject_manual" class="form-control"/>
                    <span v-if="errorSubjectManual" class="has-error help-block text-danger">{{ errorSubjectManual }}</span>
                  </div>

                  <div class="form-group " >
                    <label for="bodyManual" class="required">Text body</label>
                    <trumbowyg id="bodyManual" style="height: 200px" v-model="template.body_manual" :config="config" class="form-control" @tbw-paste="cleanUrl"></trumbowyg>
                    <span v-if="errorBodyManual" class="has-error help-block text-danger">{{ errorBodyManual }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12">

              <div class="hpanel">

                <div class="panel-heading hbuilt">
                  Organisation contact
                </div>

                <div class="panel-body">
                  <div class="form-group">
                    <label for="subjectManual" class="required">Subject</label>
                    <input id="subjectOrganisation" v-model="template.subject_organisation" class="form-control"/>
                    <span v-if="errorSubjectOrganisation" class="has-error help-block text-danger">{{ errorSubjectOrganisation }}</span>
                  </div>

                  <div class="form-group " >
                    <label for="bodyOrganisation" class="required">Text</label>
                    <trumbowyg id="bodyOrganisation" style="height: 200px" v-model="template.body_organisation" :config="config" class="form-control" @tbw-paste="cleanUrl"></trumbowyg>
                    <span v-if="errorBodyOrganisation" class="has-error help-block text-danger">{{ errorBodyOrganisation }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12" >
              <div class="bg-info" style="padding: 15px">
                <div>
                  <span class="">[%SOLVER_LASTNAME%] : </span><span>Expert last name</span>
                </div>
                <div>
                  <span>[%PUBLICATION_TITLE%] : </span><span>Title of the most recent expert publication of interest</span>
                </div>
                <div>
                  <span>[%QUESTION_TITLE%] : </span><span>Your question title</span>
                </div>
                <div>
                  <span>[%PROJECT_TITLE%] : </span><span>Your project title</span>
                </div>
                <div>
                  <span>[%URL%] : </span><span>Automated link made available to the expert to read the question</span>
                </div>
              </div>
            </div>

          </div>

        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="hpanel">
              <div class="panel-heading">
                Actions
              </div>
              <div class="panel-body text-center">
                <div class="col-xs-4 border-right">
                  <router-link class="btn btn-info" :to="{name: 'MailingReview', params: {project_id: projectId, question_id: questionId}}"><i class="fa fa-arrow-left"></i> Back to Mailing review</router-link>
                </div>
                <div class="col-xs-4 border-right">
                </div>
                <div class="col-xs-4">
                  <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle"><i class="fa fa-arrow-right"></i> Expert Selection</vue-ladda>
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>
</template>

<style >
  .trumbowyg-box {
    margin: 0;
  }

</style>
<style scoped>
  /*.btn-success[disabled] {*/
  /*background-color: white;*/
  /*color:#62cb31;*/
  /*}*/
  /*.btn-success.btn-outline:hover {*/
  /*color:white;*/
  /*background-color: #62cb31;*/
  /*}*/
</style>

<script>
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  props: [],
  name: 'Mailing',
  methods: {
    cleanUrl: function (event) {
      let value = event.target.value

      if (value !== null) {
        let result = value.match(/href="(?:http|https)(?:.*)(\[%URL%\])"/)
        let newValue = null
        if (result !== null && typeof result[1] !== 'undefined' && result[1] === '[%URL%]') {
          newValue = value.replace(result[0], 'href="[%URL%]"')
        }

        $(event.currentTarget).trumbowyg('html', newValue)
      }
    },
    getResources: function () {
      if (this.mailingId === null || typeof this.mailingId === 'undefined') {
        this.axios.get('/question/' + this.questionId + '/template/')
          .then((response) => {
            this.template = response.data
          }).catch((error) => {
            if (error.response.status === 403) {
              this.$router.replace({name: 'Error403', params: {'0': ''}})
            }
            if (error.response.status === 404) {
              this.$router.replace({name: 'Error404', params: {'0': ''}})
            }
          })
      } else {
        this.axios.get('/question/' + this.questionId)
          .then((response) => {
            let mailing = response.data.mailing.find((mailing) => {
              return mailing.id === this.mailingId
            })
            this.template = mailing.template
          }).catch((error) => {
            if (error.response.status === 403) {
              this.$router.replace({name: 'Error403', params: {'0': ''}})
            }
            if (error.response.status === 404) {
              this.$router.replace({name: 'Error404', params: {'0': ''}})
            }
          })
      }

      if (this.projectId !== null) {
        this.axios.get('/project/' + this.projectId)
          .then((response) => {
            this.project = response.data
          }).catch((error) => {
            if (error.response.status === 403) {
              this.$router.replace({name: 'Error403', params: {'0': ''}})
            }
            if (error.response.status === 404) {
              this.$router.replace({name: 'Error404', params: {'0': ''}})
            }
          })
      }
    },
    submitTemplate: function (e) {
      e.preventDefault()
      this.submit.loading = true

      let method = 'post'
      let url = '/question/' + this.questionId + '/template/'

      if (typeof this.template.id !== 'undefined') {
        method = 'patch'
        url += this.template.id
      }

      this.axios[method](url, {
        subject: this.template.subject,
        subject_manual: this.template.subject_manual,
        body: this.template.body,
        body_manual: this.template.body_manual,
        subject_organisation: this.template.subject_organisation,
        body_organisation: this.template.body_organisation
      })
        .then((response) => {
          this.submit.loading = false
          let mailing = response.data

          this.$router.replace({ name: this.$route.name, params: {project_id: this.projectId, question_id: this.questionId, mailing_id: mailing.id}})
          this.$router.push({name: 'MailingExpertSelection', params: {project_id: this.projectId, question_id: this.questionId, mailing_id: mailing.id}})
        }).catch((error) => {
          let errors = error.response.data.errors
          switch (error.response.data.code) {
            case 1:
              this.errorSubject = errors['subject'][0]
              break
            case 2:
              this.errorSubjectManual = errors['subject_manual'][0]
              break
            case 3:
              this.errorBody = errors['body'][0]
              break
            case 4:
              this.errorBodyManual = errors['body_manual'][0]
              break
            case 5:
              this.errorSubjectOrganisation = errors['subject_organisation'][0]
              break
            case 6:
              this.errorBodyOrganisation = errors['body_organisation'][0]
              break
          }
          this.submit.loading = false
        })
    }

  },
  data () {
    return {
      template: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      },
      errorSubject: null,
      errorSubjectManual: null,
      errorBody: null,
      errorBodyManual: null,
      errorSubjectOrganisation: null,
      errorBodyOrganisation: null,
      config: {
        autogrow: true
      },
      projectId: null,
      questionId: null,
      mailingId: null,
      project: null
    }
  },
  beforeMount () {
    this.projectId = parseInt(this.$route.params.project_id)
    this.questionId = parseInt(this.$route.params.question_id)
    this.mailingId = typeof this.$route.params.mailing_id === 'undefined'
      ? null : parseInt(this.$route.params.mailing_id)

    this.getResources()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/mailing/Mailing.vue